const getCurrentSortParams = (sortParams?: string) => {
  const [name = 'popular', value = -1] = sortParams?.split(':') ?? [];
  return { name, value: Number(value) } as SelectedSort;
};

export default getCurrentSortParams;
